<template>
	<div
		class="block-notify"
		:class="[blockStateClassName, blockVariantClassName]"
	>
		<!-- DEV NOTES: the icon is optional and isn't shown by default. The variation of icons should be added or removed based on notification requirement -->
		<div class="block-notify__status-icon">
			<!--DEV: this icon should change depending the block variant-->
			<i :class="iconClass"></i>
		</div>
		<div class="block-notify__content">
			<span class="block-notify__content-title"> {{ title }} </span>
			<p class="block-notify__content-message">
				{{ message }}
			</p>
		</div>
	</div>
</template>
<!-- DEV NOTES: BEHAVIOUR ------
** The purpose of this notification is to inform a user of important information after an action has been taken.
** The notification is added to content on a page therefore should run full width within content restraints.
** The notification is using the informational color variation by default.
** The corresponding icons are controlled in the css and will show per requiremnets.

** For a success notification add <div class="block-notify block-notify--success"> use "icon-success"
** For a warning notification add <div class="block-notify block-notify--warning"> use "icon-warning"
** For an error notification add <div class="block-notify block-notify--error">    use "icon-error"

** FOR MOBILE: if there is still an error in a section after a user proceeds, the user will be scrolled up to the first block notification on the screen.
-->

<script>
export default {
	name: 'BlockNotifications',
	props: {
		title: {
			type: String,
			default: ''
		},
		message: {
			type: String,
			default: ''
		},
		blockState: {
			type: String,
			default: 'info'
		},
		blockVariant: {
			type: String,
			default: ''
		}
	},
	computed: {
		blockStateClassName() {
			if (this.blockState) {
				return `block-notify--${this.blockState}`;
			}
			return '';
		},
		blockVariantClassName() {
			if (this.blockVariant) {
				return `block-notify--${this.blockVariant}`;
			}
			return '';
		},
		iconClass() {
			return `icon icon-${this.blockState}`;
		}
	}
};
</script>

<style lang="scss" scoped>
/**
    * [Description]
    *
    * Block Notifications
    * Notification Color Variations and icons
    * Can use SCSS variables = TRUE
 */

.block-notify {
	display: flex;
	padding: $padding-md;
	background-color: $ui-neutral-light;
	border: 2px solid $ui-neutral;
	border-radius: $notify-border-radius;
	border-left-width: $notify-border-thick;

	&:not(:last-child) {
		margin-bottom: $gutter-md;
	}

	@include text-contrast($ui-neutral-light, $white, $black);

	&__status-icon {
		font-size: $default-font-size + 6;
		margin-right: $gutter-md;
	}
	&__content {
		font-size: $default-font-size - 2;

		&-title {
			font-weight: $medium-font-weight;
		}
		&-message {
			padding-top: $padding-xs;
			font-size: inherit;
		}
	}

	&--success {
		background-color: $ui-positive-light;
		border-color: $ui-positive;
		@include text-contrast($ui-positive-light, $white, $black);
	}
	&--warning {
		background-color: $ui-warning-light;
		border-color: $ui-warning;
		@include text-contrast($ui-warning-light, $white, $black);
	}
	&--error {
		background-color: $ui-negative-light;
		border-color: $ui-negative;
		@include text-contrast($ui-negative-light, $white, $black);
	}

	&--small {
		padding: $padding-xs;
		border-radius: $notify-small-border-radius;
		border-left-width: 2px;

		.block-notify__status-icon {
			font-size: $default-font-size - 2;
			margin-right: $gutter-sm;
		}

		.block-notify__content {
			font-size: $default-font-size - 4;

			&-message {
				padding-top: 0;
			}
		}
	}
}
</style>
